import requestFunctions from "../../functions/requestFunctions";


export const state = {
  TRUNKS_ITEM: {},
  TRUNKS_LIST: [],
  TRUNKS_TABLE_DATA: [],
  TRUNKS_LIST_DATA: [],
  TRUNKS_TOTAL_ROWS: 0
}

export const getters = {
  GET_TRUNKS_ITEM: (state) => {
    return state.TRUNKS_ITEM;
  },
  GET_TRUNKS_LIST: (state) => {
    return state.TRUNKS_LIST;
  },
  GET_TRUNKS_TABLE_DATA: (state) => {
    return state.TRUNKS_TABLE_DATA;
  },
  GET_TRUNKS_LIST_DATA: (state) => {
    return state.TRUNKS_LIST_DATA;
  },
  GET_TRUNKS_TOTAL_ROWS: (state) => {
    return state.TRUNKS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_TRUNKS_ITEM(state, item) {
    state.TRUNKS_ITEM = item;
  },

  UPDATE_TRUNKS_LIST(state, list) {
    
    state.TRUNKS_LIST = list.data;

    state.TRUNKS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.TRUNKS_TABLE_DATA = [];
    state.TRUNKS_LIST_DATA = [];

    list.forEach(el => {

      let status =  el.status;

      if(status === 'created')  { status = 'Новый' }
      if(status === 'connect')  { status = 'Подключение' }
      if(status === 'active')   { status = 'Активен' }
      if(status === 'disabled') { status = 'Отключен' }
      if(status === 'blocked')  { status = 'Заблокирован' }

      let fullname = '';

      if (el.profile_name3) { fullname = fullname + el.profile_name3 + ' '; }
      if (el.profile_name1) { fullname = fullname + el.profile_name1 + ' '; }
      if (el.profile_name2) { fullname = fullname + el.profile_name2 + ' '; }

      let acc_name = el.account_number;

      if (acc_name !== '') {
        acc_name = acc_name + ', ';
      }
      acc_name = acc_name + el.user_phone;

      if (fullname !== '') {
        if (acc_name !== '') {
          acc_name = acc_name + ', ';
        }
        acc_name = acc_name + fullname;
      }

      state.TRUNKS_TABLE_DATA.push({
        'name' : el.name,
        'operator_name' : el.operator_name,
        'account_number': acc_name,
        'status' : status,
        'qnt_phones' : el.qnt_phones,
        'uuid' : el.uuid,
        'id' : el.id,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });

      state.TRUNKS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_TRUNKS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TRUNKS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_TRUNKS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TRUNKS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_TRUNKS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TRUNKS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TRUNKS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}